import axios from "axios";
import { SERVER } from "../static/server";
import { refresh, refreshErrorHandle } from "./refresh";

export const postForm = async (url, params, headers) => {
  let formData = new FormData();
  for (let key in params) {
    formData.append(key, params[key]);
  }

  return axios
    .post(`${SERVER}${url}`, formData, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err.response;
    });
};

export const get = async (url, params, headers) => {
  return axios
    .get(`${SERVER}${url}`, {
      params,
      headers,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err.response;
    });
};

export const post = async (url, params, headers) => {
  return axios
    .post(`${SERVER}${url}`, params, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
};

export const del = async (url, params, headers) => {
  return axios
    .delete(`${SERVER}${url}`, { data: params, headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err.response;
    });
};

export const putForm = async (url, params, headers) => {
  let formData = new FormData();
  for (let key in params) {
    formData.append(key, params[key]);
  }

  return axios
    .put(`${SERVER}${url}`, formData, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err.response;
    });
};

export const put = async (url, params, headers) => {
  return axios
    .put(`${SERVER}${url}`, params, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });
};

const Api = axios.create({
  baseURL: SERVER,
  timeout: 10000,
  params: {},
});

Api.interceptors.request.use(refresh, refreshErrorHandle);

export default Api;
